import React from "react";
import Carousel from "@/bit/components/components.carousel";
import Text from "@/bit/components/components.text";
import Slide from "./slide";
import emptyContent from "./emptyContent.json";
import { getFinalUrl } from "@gcloud-npm/utils.common.get-final-url";
import { SSR_DISPOSITIVOS_CONSTANTS } from "@gcloud-npm/utils.constants";

const ProductThumbs = ({
  taggingInfo,
  query,
  cmsHandler,
  alias,
  blockName,
  listIndex,
  parentIndex,
  frontalListToDelete,
  CmsAddElement,
  CmsEditableGroupIcons,
  ...restProps
}) => {
  const productSingleThumbList = restProps["cms-ml-product-thumbs-1"];

  // Añadir elemento
  const addElementCmp = (index = "start") =>
    CmsAddElement && (
      <CmsAddElement
        key={`add-product-thumb-${index}`}
        addProps={{
          index,
          contentId: blockName,
          itemIdDotNotation: `${blockName}.cms-component-product-thumbs.${listIndex}.cms-ml-product-thumbs-1`,
        }}
        cmsHandler={cmsHandler}
      />
    );

  return (
    <>
      <div
        className="col-xs-12 col-sm-6 col-md-9 product-thumbs"
        data-cy="FeaturedSection Carousel"
      >
        {/* Bolitas de edicion aqui */}
        {CmsEditableGroupIcons && (
          <CmsEditableGroupIcons
            elementProps={{}}
            deleteProps={{
              index: parentIndex,
              itemIdDotNotation: `${blockName}.cms-component-product-thumbs`,
              alias,
              frontalListToDelete,
            }}
            visibleTools={{
              hiring: false,
              edit: false,
              deleteItem: true,
            }}
            cmsHandler={cmsHandler}
          />
        )}
        {restProps["cms-atom-text-1"] && (
          <Text
            {...restProps["cms-atom-text-1"]}
            cmsHandler={cmsHandler}
            className="carousel-title"
          />
        )}

        {/* Cuando no hay elementos */}
        {process.env.NEXT_PUBLIC_ASTRO_MAKER &&
          productSingleThumbList &&
          Array.isArray(productSingleThumbList) &&
          productSingleThumbList.length === 0 && (
            <Carousel slideSeparation={8}>
              {[
                addElementCmp("start"),
                <Slide
                  key="empty-product-thumb"
                  img={emptyContent["cms-atom-image-1"]}
                  title={emptyContent["cms-atom-text-1"]}
                />,
              ].filter(Boolean)}
            </Carousel>
          )}

        {/* Default case */}
        {productSingleThumbList &&
          Array.isArray(productSingleThumbList) &&
          productSingleThumbList.length > 0 && (
            <Carousel slideSeparation={8}>
              {[
                addElementCmp("start"),
                ...productSingleThumbList.map((item, index) => (
                  <Slide
                    key={`${item.title}-${index}`}
                    img={item["cms-atom-image-1"]}
                    title={item["cms-atom-text-1"]}
                    link={{
                      ...item["cms-atom-link-1"],
                      href: getFinalUrl({
                        href: item["cms-atom-link-1"].href,
                        currentQueryParams: query,
                        queryParamsToKeep:
                          SSR_DISPOSITIVOS_CONSTANTS.QUERY_PARAMS_TO_KEEP,
                      }),
                    }}
                    cmsHandler={cmsHandler}
                    taggingInfo={taggingInfo}
                    alias={alias}
                    blockName={blockName}
                    index={index}
                    listIndex={listIndex}
                    frontalListToDelete={productSingleThumbList}
                    CmsEditableGroupIcons={CmsEditableGroupIcons}
                  />
                )),
                addElementCmp("end"),
              ].filter(Boolean)}
            </Carousel>
          )}
      </div>
      <style jsx>{`.product-thumbs {
  margin-bottom: 1.5rem;
  :global(.carousel) {
    :global(.carousel-window) {
      padding-right: 0.9375rem;
    }
  }
  :global(.carousel-title) {
    margin: 0.5rem 0.2rem;
  }
}

// Tablet
@media screen and (min-width: 768px) {
  .device-carousel {
    :global(.carousel) {
      padding: 0;
    }
  }
}

// Desktop
@media screen and (min-width: 1224px) {
}
`}</style>
    </>
  );
};

export default ProductThumbs;
